import React from "react";
import L from "leaflet";
import { Polygon, Polyline, Tooltip } from "react-leaflet";
interface polygonProps {
  text: string;
  pathOptions: any;
  eventHandlers: any;
  positions: any;
}

const PolygonWithText = (props: polygonProps) => {
  const { text, pathOptions, eventHandlers, positions } = props;
  const center = L.polygon(positions).getBounds().getCenter();
  const text_html = L.divIcon({
    html: `<p class='district_name_label' style="background:transparent;color:${pathOptions.color};opacity:0.8">${text}</p>`,
  });

  return (
    <Polygon
      pathOptions={pathOptions}
      eventHandlers={eventHandlers}
      positions={positions}
    >
      <Tooltip sticky>{text}</Tooltip>
      {/* <Marker
        position={{
          lat: center.lat + 3,
          lng: center.lng - 5,
        }}
        icon={text_html}
      /> */}
    </Polygon>
  );
};

export default PolygonWithText;
